// src/pages/Forbidden.js
import React from "react";
import {
  Box,
  Heading,
  Text,
  Center,
  Link,
  VStack,
} from "@chakra-ui/react";
import { supabasePublic } from "./supabaseClient";
import { basename } from "./env";
import { recordAuthEvent } from "../services/rlsAudit";

const Forbidden = () => {
  const handleSignIn = async (e) => {
    e.preventDefault();
    // Sign out first so AuthUI doesn’t auto-redirect back to /schedules (which causes the 403 loop)
    await recordAuthEvent("logout");
    await supabasePublic().auth.signOut();
    window.location.href = window.location.origin + (basename || "") + "/auth";
  };

  return (
    <Center height="100vh" bg="gray.50">
      <Box textAlign="center" py={10} px={6}>
        <Heading as="h1" size="xl" color="#3b5998" mb={4}>
          403 - Forbidden
        </Heading>
        <Text fontSize="lg" color="gray.500">
          You don’t have permission to access this page.
        </Text>

        <VStack mt={10} spacing={4}>
          <Text fontSize="md" color="gray.500">
            Not signed in?{" "}
            <Link
              href="#"
              onClick={handleSignIn}
              color="#3b5998"
              fontWeight="bold"
            >
              Sign In here.
            </Link>
          </Text>
        </VStack>
      </Box>
    </Center>
  );
};

export default Forbidden;
